module.exports = __webpack_public_path__ + "img/img_catalog.7dca95d5.jpg";